import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import HeadLineBox from './HeadLineBox';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      [theme.breakpoints.down('xs')]: {
        borderRadius: 8,
      },
    },
  }),
);

interface Props {
  onHelpClick?: (props: any) => void;
  title: string | React.ReactElement;
  description?: string | null;
  helpIcon?: boolean;
}

const QuestionMark: React.FC<Props> = ({ onHelpClick, title, description, helpIcon, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeadLineBox
        onHelpClick={(open: boolean) => onHelpClick && onHelpClick(open)}
        title={title}
        description={description}
        helpIcon={helpIcon}
      />
      {children}
    </div>
  );
};

export default QuestionMark;
